var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v(" Tous droits réservés à qui de droit. ©® Toutes marques présentes sont enregistrées auprès d'autorités probablement compétentes. ")])}
var staticRenderFns = []

export { render, staticRenderFns }